export default __webpack_public_path__ + "static/howtheskinisattached-274e1e76c6a3baf1a02bac74a9905a10.png";